import { api } from '@api/api2';
import type { GetResidentAccountStatusPayload } from './types';

export const getResidentAccountStatus = (payload: GetResidentAccountStatusPayload) =>
  api.v4('get', 'personal-account/relation/resident/type-list', payload);
